import { ApplicationConfig, inject, isDevMode, provideAppInitializer } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs';

/** Activate new service workers immediately so routing fixes reach existing visitors. */
export function provideServiceWorkerUpdates(): ApplicationConfig['providers'] {
  if (isDevMode()) {
    return [];
  }

  return [
    provideAppInitializer(() => {
      const swUpdate = inject(SwUpdate);
      if (!swUpdate.isEnabled) {
        return;
      }

      swUpdate.versionUpdates
        .pipe(filter((event): event is VersionReadyEvent => event.type === 'VERSION_READY'))
        .subscribe(() => {
          swUpdate.activateUpdate().catch(() => undefined);
        });

      swUpdate.checkForUpdate().catch(() => undefined);
    }),
  ];
}
